/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetStatsByDriversReportQueryParams,
  GetStatsByDriversReport200,
  GetStatsByDriversReport400,
  GetStatsByDriversReportQueryResponse,
} from '../entities/GetStatsByDriversReport'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const getStatsByDriversReportQueryParamsSchema = z
  .object({
    drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
    from: z.string().describe('Начальная дата').optional(),
    phone: z.string().describe('Номер водителя').optional(),
    to: z.string().describe('Конечная дата').optional(),
  })
  .optional() as unknown as ToZod<GetStatsByDriversReportQueryParams>

/**
 * @description Binary file
 */
export const getStatsByDriversReport200Schema = z.instanceof(File) as unknown as ToZod<GetStatsByDriversReport200>

/**
 * @description Bad Request
 */
export const getStatsByDriversReport400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDriversReport400>

export const getStatsByDriversReportQueryResponseSchema = z.lazy(
  () => getStatsByDriversReport200Schema,
) as unknown as ToZod<GetStatsByDriversReportQueryResponse>